import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import compose from "recompose/compose";
import {connect} from "react-redux";
import _ from 'lodash';
import classNames from "classnames";

import Button from '@material-ui/core/Button';
import TableCell from "@material-ui/core/TableCell";
import DateRange from '@material-ui/icons/DateRange';

import CurrencyFormat from "./input/currency-format";
import NullableNumberFormat from "./input/nullable-number-format";
import TextInput from "./input/text-input";
import Checkbox from "./input/check-box";
import Dropdown from "./input/drop-down";

import NumberEditor from './components/filter-number-editor'
import {TableComponent,Row} from "./components/table-components";
import VirtualHeadComponent from "./components/virtual-table-components";

import {
	Plugin, Getter, TemplateConnector, Template, TemplatePlaceholder,
} from '@devexpress/dx-react-core';

import {
	FilteringState,
	IntegratedFiltering,
	IntegratedPaging,
	IntegratedSelection,
	IntegratedSorting,
	PagingState,
	SelectionState,
	SortingState,
	DataTypeProvider,
} from '@devexpress/dx-react-grid';

import {
	Grid, PagingPanel,
	Table, TableFilterRow,
	TableHeaderRow, TableSelection, TableColumnResizing, VirtualTable,
} from '@devexpress/dx-react-grid-material-ui';



import {
	COL_TYPE,
	DATE_FILTER_OPERATIONS,
	FILTER_MESSAGE,
	PAGE_MESSAGE,
	TABLE_MESSAGE,
	NUMBER_FILTER_OPERATIONS,
	getColumnFilterDisabled,
	getColumnSortingDisabled,
	getColumnWidth,
	getDateColumns,
	getNumberColumns,
	getRowId,
	tableStyle,
	getDateFilteringColumnExtensions,
	getErrors,
	getRowIndexFromId, getError
} from "../../utils/tables";


import {
	addEditableTableRow, delEditableTableRow,
	setEditableTableState,
} from "../../../actions/components";


import {isSameObject} from "../../utils/array";
import {getErrorColor, getPrimaryColor} from "../../const";


const mapStateToProps = state => {
	return {
		tableState : state.componentsEditableTableState,
	};
}

const styles = theme=> Object.assign({},tableStyle,{
	EditCell: {
		paddingLeft:8,
		paddingRight:8,
		'&:first-child':{
			paddingLeft: 24
		},
		verticalAlign:'top'
	},
	viewCell:{
		verticalAlign:'middle !important'
	},
	numberViewCell:{
		textAlign: 'right'
	},
	negativeStyle:{
		color:getErrorColor()
	},
	clickableText:{
		color:getPrimaryColor(),
		cursor:'pointer'
	},
	addRowButton:{
		marginTop:10
	}

});


/******** COMPONENTS *********/
/*ICON*/
const FilterIcon = ({ type, ...restProps }) => {
	if (type === 'month') return <DateRange {...restProps} />;
	return <TableFilterRow.Icon type={type} {...restProps} />;
};


/* CELL OBJECTS */
class cellComponentBase extends Component{



	render(){

		const {column,classes} = this.props;

		const Component = () => {
			switch(column.type){
				case COL_TYPE.NUMBER:
					return <NumberViewCell {...this.props}/>;
				case COL_TYPE.NULLABLE_NUMBER:
					return <NullableNumberViewCell {...this.props}/>;
				case COL_TYPE.EDIT:
					return <EditCell {...this.props}/>;
				case COL_TYPE.EDIT_NUM:
					return <CurrencyEditCell {...this.props}/>;
				case COL_TYPE.EDIT_NULLABLE_NUM:
					return <NullableNumberEditCell {...this.props}/>;
				case COL_TYPE.BUTTON:
					return <ButtonCell {...this.props}/>;
				case COL_TYPE.CHECK:
					return <CheckCell {...this.props}/>;
				case COL_TYPE.EDIT_SELECT:
					return <SelectCell {...this.props}/>;
				case COL_TYPE.CLICK_TEXT:
				case COL_TYPE.CLICK_NUMBER:
					return <ClickTextCell {...this.props}/>
				case COL_TYPE.DELETE_ROW_BUTTON:
					return <DeleteButtonCell {...this.props}/>;
				default:
					return <ViewCell {...this.props}/>;
			}
		}
		const editableCell = [
			COL_TYPE.EDIT,
			COL_TYPE.EDIT_NUM,
			COL_TYPE.EDIT_NULLABLE_NUM,
			COL_TYPE.EDIT_SELECT
		];
		const isEditCell = Boolean(editableCell.indexOf(column.type) !== -1);

		return(
			<TableCell
				className={classNames(classes.EditCell,!isEditCell ? classes.viewCell : '')}
			>
				<Component />
			</TableCell>
		);
	}

}
export const CellComponent = withStyles(styles, { name: 'CellComponent' })(cellComponentBase);

const getCellValue = (rows,id,name,type)=>{
	const index = _.findIndex(rows,{'id':id});
	if(index === -1){
		switch (type){
			case COL_TYPE.NUMBER:
			case COL_TYPE.CLICK_NUMBER:
			case COL_TYPE.EDIT_NUM:
			case COL_TYPE.CHECK:
				return 0;
			case COL_TYPE.DATE:
			case COL_TYPE.EDIT_DATE:
				return null;
			default :
				return '';
		}
	}
	switch(type){
		case COL_TYPE.EDIT:
		case COL_TYPE.EDIT_SELECT:
			return !(rows[index][name]) ? '' : rows[index][name]
		case COL_TYPE.NUMBER:
			return !(rows[index][name]) ? 0 : Number(rows[index][name])
		case COL_TYPE.CHECK:
			return Number(rows[index][name])
		default:
			return rows[index][name];
	}

}

/*check*/
class selectCellBase extends Component{

	render() {
		const {tableState, column, row} = this.props;

		const value = getCellValue(tableState.rows, getRowId(row), column.name, column.type);
		const hasBlank = Boolean(column.hasBlank);
		const defaultValue = !column.defaultValue ? '' : column.defaultValue;
		const disabled = column.disabled || tableState.readOnly;
		return (
			<Dropdown
				id={getRowId(row)}
				name={column.name}
				value={value}
				dataSource={column.selectDataSource}
				defaultValue={defaultValue}
				hasBlank={hasBlank}
				disabled={disabled}
			/>
		)
	}
}
export const SelectCell = compose(withStyles(styles),connect(mapStateToProps))(selectCellBase);


/*check*/
class checkCellBase extends Component{
	render() {
		const {tableState, column, row} = this.props;

		const value = getCellValue(tableState.rows, getRowId(row), column.name, column.type);
		const disabled = column.disabled || tableState.readOnly;
		return (
			<Checkbox
				id={getRowId(row)}
				name={column.name}
				value={value}
				disabled={disabled}
			/>
		)
	}
}
export const CheckCell = compose(withStyles(styles),connect(mapStateToProps))(checkCellBase);

/*button*/
class buttonCellBase extends Component{

	render() {
		const {column, row,tableState} = this.props;
		const onClick = () => {
			column.func(getRowId(row));
		}
		const disabled = column.disabled || tableState.readOnly;
		return (
			<Button variant="contained" size="small" onClick={onClick} disabled={disabled}>
				{column.buttonText}
			</Button>
		)
	}
}
export const ButtonCell = compose(withStyles(styles),connect(mapStateToProps))(buttonCellBase);


class deleteButtonCellBase extends Component{
	render() {
		const {row, dispatch,tableState,column} = this.props;
		const onClick = () => {
			dispatch(delEditableTableRow({id:getRowId(row)}));
		}
		const disabled = column.disabled || tableState.readOnly;

		return (
			<Button
				variant="contained"
				size="small"
				onClick={onClick}
				disabled={disabled}
			>
				削除
			</Button>
		)
	}
}
export const DeleteButtonCell = compose(withStyles(styles),connect(mapStateToProps))(deleteButtonCellBase);



class clickTextCellBase extends Component{
	render() {
		const {tableState, classes, column, row} = this.props;
		const value = getCellValue(tableState.rows, getRowId(row), column.name, column.type);
		const onClick = () => {
			column.func(getRowId(row));
		}
		return (
			<p className={classes.clickableText} onClick={onClick}>
				{value}
			</p>
		)
	}
}
export const ClickTextCell = compose(withStyles(styles),connect(mapStateToProps))(clickTextCellBase);

/*view*/
class viewCellBase extends Component{
	render() {
		const {tableState, column, row} = this.props;
		const value = getCellValue(tableState.rows, getRowId(row), column.name, column.type);
		return (
			<p>
				{value}
			</p>
		)
	}
}
export const ViewCell = compose(withStyles(styles),connect(mapStateToProps))(viewCellBase);


/*number view*/
class numberViewCellBase extends Component{
	render() {
		const {classes,tableState, column, row} = this.props;
		const value = getCellValue(tableState.rows, getRowId(row), column.name, column.type);
		return (
			<p variant="body1" className={classNames(classes.numberViewCell, (value < 0) ? classes.negativeStyle : "")}>
				{new Intl.NumberFormat('ja-JP').format(value)}
			</p>
		)
	}
}
export const NumberViewCell = compose(withStyles(styles),connect(mapStateToProps))(numberViewCellBase);

/*nullable number view*/
class nullableNumberViewCellBase extends Component{
	render() {
		const {classes,tableState, column, row} = this.props;
		const value = getCellValue(tableState.rows, getRowId(row), column.name, column.type);
		const viewValue = (value === '') ? '' :  new Intl.NumberFormat('ja-JP').format(value);

		return (
			<p variant="body1" className={classNames(classes.numberViewCell, (value < 0) ? classes.negativeStyle : "")}>
				{viewValue}
			</p>
		)
	}
}
export const NullableNumberViewCell = compose(withStyles(styles),connect(mapStateToProps))(nullableNumberViewCellBase);

/*Edit Text*/
class editCellBase extends Component{
	render() {
		const {tableState,column, row} = this.props;
		const {readOnly,errors,rows} = tableState;

		const value = getCellValue(tableState.rows, getRowId(row), column.name, column.type);
		const val = !(value) ? '' : String(value);
		const disabled = column.disabled || readOnly;
		const error = getError(getRowIndexFromId(rows,getRowId(row)),errors,column.name);
		return (
			<TextInput
				id={getRowId(row)}
				name={column.name}
				value={val}
				disabled={disabled}
				error={error}
				maxLength={column.maxLength}
			/>
		)
	}
}
export const EditCell = compose(withStyles(styles),connect(mapStateToProps))(editCellBase);


/*Edit Number*/
class currencyEditCellBase extends Component{
	render() {
		const {tableState,column, row} = this.props;
		const {readOnly,errors,rows} = tableState;

		const value = getCellValue(tableState.rows, getRowId(row), column.name, column.type);
		const val = !(value) ? 0 : Number(value);
		const disabled = column.disabled || readOnly;
		const error = getError(getRowIndexFromId(rows,getRowId(row)),errors,column.name);

		const max = (column.max == null) ? 9999999999 : column.max;
		const min = (column.min == null) ? -9999999999 : column.min;

		return (
			<CurrencyFormat
				id={getRowId(row)}
				name={column.name}
				value={val}
				disabled={disabled}
				error={error}
				max={max}
				min={min}
			/>
		)
	}
}
export const CurrencyEditCell = compose(withStyles(styles),connect(mapStateToProps))(currencyEditCellBase);

/*Edit Nullable Number*/
class nullableNumberEditCellBase extends Component{
	render() {

		const {tableState,column, row} = this.props;
		const {readOnly,errors,rows} = tableState;

		const value = getCellValue(tableState.rows, getRowId(row), column.name, column.type);
		const val = !(value) ? '' : String(value);
		const disabled = column.disabled || readOnly;
		const error = getError(getRowIndexFromId(rows,getRowId(row)),errors,column.name);
		const max = (column.max == null) ? 9999999999 : column.max;
		const min = (column.min == null) ? -9999999999 : column.min;

		return (
			<NullableNumberFormat
				id={getRowId(row)}
				name={column.name}
				value={val}
				disabled={disabled}
				error={error}
				max={max}
				min={min}
			/>
		)
	}
}
export const NullableNumberEditCell = compose(withStyles(styles),connect(mapStateToProps))(nullableNumberEditCellBase);



/******** Integrate *********/
const PatchedIntegratedSortingFiltering =({data,sorting,filterColumnExtensions, ...restProps }) => {
	return (
		<Plugin>
			<Getter
				name="rows"
				computed={() => data}
			/>
			<IntegratedFiltering columnExtensions={filterColumnExtensions} {...restProps} />
			<Getter
				name="sorting"
				computed={() => sorting}
			/>
			<IntegratedSorting {...restProps} />
		</Plugin>
	)
}

const rowSelectionEnabled = row => !(row.isSelectionDisabled === "1");
class PatchedIntegratedSelection extends Component {
	render() {
		const { data, rowSelectionEnabled, ...restProps } = this.props;
		return (
			<Plugin>
				<Getter
					name="rows"
					computed={({ rows }) => {
						this.rows = rows;
						return rows.filter(rowSelectionEnabled);
					}}
				/>
				<IntegratedSelection {...restProps} />
				<Getter
					name="rows"
					computed={() => this.rows}
				/>
			</Plugin>
		)
	}
}
class PatchedTableSelection extends Component {
	render() {
		const { rowSelectionEnabled, ...restProps } = this.props;
		return (
			<TableSelection
				cellComponent={(props) => rowSelectionEnabled(props.tableRow.row) ? (
					<TableSelection.Cell {...props} />
				) : (
					<Table.StubCell {...props} />
				)}
				{...restProps}
			/>
		);
	}
}

const getSelectionFromRows = (rows) =>{

	const checkRow = _.filter(rows,'isSelected');
	return checkRow.map(row =>getRowId(row));
}


const getRequiredFields = (columns) =>{
	return columns.filter(column=>column.isRequired).map(column=>column.name);
}


class EditableTable extends Component {
	constructor(props) {
		super(props);

		const {
			dispatch,
			dataSource,columns,readOnly,canAddRow,
			onAfterUpdateRow,pageSizes,defaultSorts,
			isDefaultHasBlankRow
		} = props;

		const updateProps = {
			rows : dataSource.concat(),
			readOnly : readOnly,
		}
		if(onAfterUpdateRow) updateProps["onAfterUpdateRow"] = onAfterUpdateRow;
		if(pageSizes) updateProps["pageSizes"] = pageSizes;
		if(defaultSorts) updateProps["sorting"] = defaultSorts;
		updateProps["requiredColumns"] = getRequiredFields(props.columns)
		const selection = getSelectionFromRows(updateProps.rows);
		updateProps["selection"] = selection;
		updateProps["errors"] = getErrors(dataSource,getRequiredFields(columns));

		this.state = {
			selection,
			isUpdate:false
		};

		dispatch(setEditableTableState(updateProps));



		if(isDefaultHasBlankRow && !readOnly && canAddRow && dataSource.length === 0){
			this.handleClickAddRow();
		}

	}
	shouldComponentUpdate(nextProps, nextState, nextContext) {
		return !isSameObject(nextProps.tableState,this.props.tableState) ||
			!isSameObject(nextProps.dataSource,this.props.dataSource) ||
			nextProps.dataSource !== this.props.dataSource ||
			nextProps.readOnly !== this.props.readOnly ||
			nextState.isUpdate ||
			nextProps.height !== this.props.height ||
			nextProps.tableState.isDeleteRow;
	}
	componentDidUpdate(prevProps, prevState, snapshot) {
		if(prevProps.dataSource !== this.props.dataSource){
			this.props.dispatch(setEditableTableState({
				rows : this.props.dataSource.concat(),
				filters : [],
				sorts : this.props.defaultSorts,
				selection : getSelectionFromRows(this.props.dataSource),
				requiredColumns : getRequiredFields(this.props.columns),
				errors:getErrors(this.props.dataSource,getRequiredFields(this.props.columns))
			}))

			if(this.props.isDefaultHasBlankRow &&
				!this.props.readOnly &&
				this.props.canAddRow &&
				this.props.dataSource.length === 0
			){
				this.handleClickAddRow();
			}
		}
		if(this.props.tableState.isDeleteRow){
			this.props.dispatch(setEditableTableState({
				isDeleteRow : false
			}))
		}
		if(prevProps.readOnly !== this.props.readOnly){
			this.props.dispatch(setEditableTableState({
				readOnly : this.props.readOnly
			}))
		}
		if(this.state.isUpdate){
			this.setState({isUpdate:false});
		}
	}
	static getDerivedStateFromProps(nextProps, prevState){
		if(!isSameObject(nextProps.tableState.selection,prevState.selection)){
			return{
				selection:nextProps.tableState.selection.concat(),
				isUpdate:true
			}
		}
		return null;
	}


	handleFiltersChange = (filters) =>{
		this.props.dispatch(setEditableTableState({
			filters,
		}))
	}
	handleSortingChange = (sorting)=>{
		this.props.dispatch(setEditableTableState({
			sorting,
		}))
	}
	handleChangeSelection = (selection) =>{
		this.setState({
			selection:selection.concat()
		});
		this.props.dispatch(setEditableTableState({
			selection,
		}))
	}
	handleClickAddRow = () =>{
		const {dispatch,columns} = this.props;
		dispatch(addEditableTableRow({columns}))
		this.setState({
			isUpdate:true
		})
	}


	render() {
		const {classes,tableState, columns,
			useSelections, useFilters, useSorts,height,readOnly,canAddRow
		} = this.props;
		const {rows, filters, sorting, selection, pageSizes} = tableState;

		const defaultColumnWidths = getColumnWidth(columns);
		const filterEnables = getColumnFilterDisabled(columns);
		const sortEnables = getColumnSortingDisabled(columns);
		const numberColumns = getNumberColumns(columns);
		const dateColumns = getDateColumns(columns);
		const dateFilterColumnExtensions = getDateFilteringColumnExtensions(columns);

		const filteringColumnExtensions = dateFilterColumnExtensions.concat();

		const isVirtualTable = Boolean(height !== -1);

		return(
			<div>
				<Grid
					rows={rows.concat()}
					columns={columns}
					getRowId={getRowId}
				>

					<DataTypeProvider
						for={dateColumns}
						availableFilterOperations={DATE_FILTER_OPERATIONS}
					/>

					<DataTypeProvider
						for={numberColumns}
						availableFilterOperations={NUMBER_FILTER_OPERATIONS}
						editorComponent={NumberEditor}
					/>

					{useFilters &&
					<FilteringState
						columnExtensions={filterEnables}
						filters={filters}
						onFiltersChange={this.handleFiltersChange}
					/>
					}
					{useSorts &&
					<SortingState
						sorting={sorting}
						columnExtensions={sortEnables}
						onSortingChange={this.handleSortingChange}
					/>
					}
					{useSelections &&
					<SelectionState
						selection={selection}
						onSelectionChange={this.handleChangeSelection}
					/>
					}
					{!isVirtualTable &&
					<PagingState
						defaultPageSize={pageSizes[0]}
					/>
					}

					{(useFilters || useSorts) &&
					<PatchedIntegratedSortingFiltering
						data={rows}
						sorting={sorting}
						columnExtensions={filteringColumnExtensions}
					/>
					}
					{useSelections &&
					<PatchedIntegratedSelection
						data={rows}
						rowSelectionEnabled={rowSelectionEnabled}
					/>
					}
					{!isVirtualTable &&
					<IntegratedPaging/>
					}
					{!isVirtualTable &&
					<Table
						tableComponent={TableComponent}
						rowComponent={Row}
						messages={TABLE_MESSAGE}
						cellComponent={CellComponent}
					/>
					}
					{isVirtualTable &&
						<VirtualTable
							tableComponent={TableComponent}
							headComponent={VirtualHeadComponent}
							rowComponent={Row}
							messages={TABLE_MESSAGE}
							cellComponent={CellComponent}
							height={height}
						/>
					}
					<TableColumnResizing defaultColumnWidths={defaultColumnWidths} />
					{useSelections &&
					<PatchedTableSelection
						showSelectAll={true}
						rowSelectionEnabled={rowSelectionEnabled}
					/>
					}
					<TableHeaderRow
						showSortingControls={useSorts}
					/>
					{useFilters &&
					<TableFilterRow
						showFilterSelector={true}
						messages={FILTER_MESSAGE}
						iconComponent={FilterIcon}
					/>
					}
					{!isVirtualTable &&
					<PagingPanel
						pageSizes={pageSizes}
						messages={PAGE_MESSAGE}
					/>
					}
					<Template name="root">
						<TemplateConnector>
							{({ rows,getCollapsedRows }) => {
								return <TemplatePlaceholder />;
							}}
						</TemplateConnector>
					</Template>
					<Template
						name="tableRow"
					>
						{params => (
							<TemplateConnector>
								{() =>
									(
										<Row
											{...params}
										/>
									)}
							</TemplateConnector>
						)}
					</Template>
				</Grid>
				{!readOnly && canAddRow &&
				<Button
					onClick={this.handleClickAddRow}
					variant="contained"
					color={"primary"}
					className={classes.addRowButton}
				>
					明細行を追加
				</Button>
				}
			</div>
		);
	}
}
EditableTable.propTypes = {
	dataSource: PropTypes.array,
	columns : PropTypes.array,
	defaultSorts : PropTypes.array,
	onAfterUpdateRow : PropTypes.func,
	useSelections : PropTypes.bool,
	useFilters : PropTypes.bool,
	useSorts : PropTypes.bool,
	height : PropTypes.number,
	dlFileName : PropTypes.string,
	isDefaultAllChecked : PropTypes.bool,
	readOnly : PropTypes.bool,
	canAddRow : PropTypes.bool,
	isDefaultHasBlankRow : PropTypes.bool
};
EditableTable.defaultProps = {
	dataSource: [],
	columns: [],
	defaultSorts : [],
	useSelections : true,
	useFilters : true,
	useSorts : true,
	height : -1,
	isDefaultAllChecked : false,
	readOnly : false,
	canAddRow : false,
	isDefaultHasBlankRow : false

};
const EditableTableConnect = compose(
	withStyles(styles),
	connect(mapStateToProps)
)(({exporterRef, ...props})=> <EditableTable exporterRef={exporterRef} {...props} />);

export default React.forwardRef((props, ref) => {
	return <EditableTableConnect {...props} exporterRef={ref} />;
});



// WEBPACK FOOTER //
// ./src/common/components/table/editable-table.js